import { computed, defineComponent, onMounted, ref, watch, } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { createObjectInOfferDetailsRoute } from '@/router/utils';
import { useBrand } from '@/composables';
import { GenericAGTable } from '@/components/Table/AGTable/AGTable.vue';
import ObjectAddressCell from '@/views/Brand/Applications/Components/Offers/Costs/_components/ObjectAddressCell.vue';
import { getObjectsList } from '@/api/v2/requests/objects';
import NoResults from '@/views/_components/NoResults.vue';
import TablePaginationV2 from '@/views/_components/Table/TablePaginationV2.vue';
import AvailabilityCell from '@/views/Brand/Applications/Components/Offers/Costs/_components/AvailabilityCell.vue';
import TableLoader from '@/views/_components/Table/TableLoader.vue';
import { useReservationColumns } from '@/views/Brand/Applications/Offer/Details/composables/use-reservation-columns';
import ReservationDecisionCell from '@/views/Brand/Applications/Components/Offers/Costs/_components/ReservationDecisionCell.vue';
import OfferExpandableCard from '@/views/Brand/Applications/Components/Offers/OfferExpandableCard.vue';
import FloatingTextFilter from '@/components/Table/AGTable/_components/FloatingTextFilter.vue';
import FloatingSelectFilter from '@/components/Table/AGTable/_components/FloatingSelectFilter.vue';
import ObjectNumberCell from '@/views/Brand/Applications/Components/Offers/ObjectNumberCell.vue';
import ObjectAcceptCell from '@/views/Brand/Applications/Components/Offers/Costs/_components/ObjectAcceptCell.vue';
import IconHeader from '@/views/Brand/Applications/Components/Offers/Costs/_components/IconHeader.vue';
const { useState } = createNamespacedHelpers('offer');
import { ObjectStatusColor, ObjectCategory, } from '@/views/Brand/Applications/Offer/Details/constants';
import ObjectDecisionCell from '@/views/Brand/Applications/Components/Offers/Costs/_components/ObjectDecisionCell.vue';
export default defineComponent({
    components: {
        OfferExpandableCard,
        TablePaginationV2,
        TableLoader,
        NoResults,
        AgTable: GenericAGTable(),
        // eslint-disable-next-line vue/no-unused-components
        ReservationDecisionCell,
        // eslint-disable-next-line vue/no-unused-components
        ObjectAddressCell,
        // eslint-disable-next-line vue/no-unused-components
        AvailabilityCell,
        // eslint-disable-next-line vue/no-unused-components
        FloatingTextFilter,
        // eslint-disable-next-line vue/no-unused-components
        FloatingSelectFilter,
        // eslint-disable-next-line vue/no-unused-components
        ObjectNumberCell,
        // eslint-disable-next-line vue/no-unused-components
        ObjectAcceptCell,
        // eslint-disable-next-line vue/no-unused-components
        IconHeader,
        // eslint-disable-next-line vue/no-unused-components
        ObjectDecisionCell,
    },
    setup(props, ctx) {
        const { brand } = useBrand();
        const { currentOffer } = useState(['currentOffer']);
        const isLoading = ref(false);
        const rows = ref([]);
        const totalCount = ref();
        const shownYear = ref(currentOffer.value?.isIndefinite ? new Date().getFullYear() : 0);
        const getObjectRoute = (object) => {
            const { id, objectType } = object;
            if (!objectType || !brand.value || !currentOffer.value)
                return '';
            return createObjectInOfferDetailsRoute(brand.value.id, id, objectType.id, currentOffer.value.id);
        };
        const { columns } = useReservationColumns(ctx, currentOffer.value, shownYear);
        const url = computed(() => {
            return `objects`;
        });
        const page = ref(1);
        const objectQuery = computed(() => {
            return {
                page: page.value,
                offerId: currentOffer.value.id,
                perPage: 500,
                withReservation: true,
            };
        });
        const fetchItems = async () => {
            isLoading.value = true;
            try {
                const { nodes, totalCount: nodesCount } = await getObjectsList(objectQuery.value ?? {});
                totalCount.value = nodesCount;
                rows.value = nodes;
                emitObjectNumbers();
            }
            catch (err) {
                ctx.root.$toast.error(ctx.root.$t(`offer-costs.error-fetching`));
            }
            finally {
                isLoading.value = false;
            }
        };
        const getRowClass = (params) => {
            if (params?.data?.isRejected) {
                return 'bg-neutral text-gray-dark';
            }
        };
        onMounted(async () => {
            await fetchItems();
        });
        watch(page, async () => {
            await fetchItems();
        });
        const hasReservations = computed(() => {
            return rows.value && rows.value.length > 0;
        });
        const emitObjectNumbers = () => {
            const objectNumbers = rows.value
                .map((obj) => obj.internalNumber)
                .filter(Boolean);
            ctx.emit('objects-loaded', {
                category: ObjectCategory.Reservation,
                internalNumbers: objectNumbers,
            });
        };
        return {
            page,
            url,
            columns,
            getObjectRoute,
            shownYear,
            objectQuery,
            rows,
            getRowClass,
            isLoading,
            totalCount,
            hasReservations,
            ObjectStatusColor,
            emitObjectNumbers,
        };
    },
});
